import React, { useState, useEffect } from "react";
import { useParams, useNavigate } from "react-router-dom";
import Select from "react-select";
import { getAllProjectsSummary } from "../../../api/projectApi";
import { selectStyles } from "../../../utils/selectStyles";
import ProjectAnalysis from "./ProjectAnalysis/ProjectAnalysis";
import "../ProjectFinance/ProjectFinance.css";

const LaborAnalysis = () => {
  const { id: projectId } = useParams();
  const navigate = useNavigate();
  const [projects, setProjects] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState("");

  useEffect(() => {
    const fetchProjects = async () => {
      try {
        const summaryData = await getAllProjectsSummary();
        if (Array.isArray(summaryData)) {
          setProjects(
            summaryData.map((p) => ({
              value: p.id,
              label: p.name || "Без названия",
            }))
          );
        }
      } catch (err) {
        setError("Не удалось загрузить список проектов");
      } finally {
        setLoading(false);
      }
    };
    fetchProjects();
  }, []);

  const handleProjectChange = (selectedOption) => {
    if (!selectedOption) {
      navigate("/projects/labor-analysis");
      return;
    }
    navigate(`/projects/labor-analysis/${selectedOption.value}`);
  };

  const selectedProjectForSelect =
    projects.find((p) => p.value === parseInt(projectId)) || null;

  return (
    <div className="finance-container">
      <div className="finance-header">
        <h1 className="finance-title">Анализ трудозатрат</h1>
        <div className="finance-project-selector">
          <Select
            styles={selectStyles}
            options={projects}
            value={selectedProjectForSelect}
            onChange={handleProjectChange}
            placeholder="Выберите проект..."
            noOptionsMessage={() => "Проекты не найдены"}
            isLoading={loading && projects.length === 0}
            isClearable
          />
        </div>
      </div>

      <div className="finance-content">
        {error && <div style={{ color: "red", marginBottom: 12 }}>{error}</div>}
        {projectId && <ProjectAnalysis projectId={projectId} />}
      </div>
    </div>
  );
};

export default LaborAnalysis;
